/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CollaborateurApercuDto
 */
export interface CollaborateurApercuDto {
    /**
     * 
     * @type {string}
     * @memberof CollaborateurApercuDto
     */
    accessId: string;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurApercuDto
     */
    abpUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurApercuDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurApercuDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurApercuDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CollaborateurApercuDto
     */
    isPrincipal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CollaborateurApercuDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the CollaborateurApercuDto interface.
 */
export function instanceOfCollaborateurApercuDto(value: object): value is CollaborateurApercuDto {
    if (!('accessId' in value) || value['accessId'] === undefined) return false;
    if (!('abpUserId' in value) || value['abpUserId'] === undefined) return false;
    if (!('isPrincipal' in value) || value['isPrincipal'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function CollaborateurApercuDtoFromJSON(json: any): CollaborateurApercuDto {
    return CollaborateurApercuDtoFromJSONTyped(json, false);
}

export function CollaborateurApercuDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollaborateurApercuDto {
    if (json == null) {
        return json;
    }
    return {
        
        'accessId': json['accessId'],
        'abpUserId': json['abpUserId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'isPrincipal': json['isPrincipal'],
        'isActive': json['isActive'],
    };
}

export function CollaborateurApercuDtoToJSON(json: any): CollaborateurApercuDto {
    return CollaborateurApercuDtoToJSONTyped(json, false);
}

export function CollaborateurApercuDtoToJSONTyped(value?: CollaborateurApercuDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessId': value['accessId'],
        'abpUserId': value['abpUserId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'isPrincipal': value['isPrincipal'],
        'isActive': value['isActive'],
    };
}

